import React, { useEffect, useState } from 'react';
import { AutoComplete, notification } from 'antd';
import { gql, useLazyQuery } from '@apollo/client';

export const SEARCH_BAINFO_QUERY = gql`
  query SearchBAInfo($input: String!) {
    bussinessAssociates(input: $input) {
      baId
      longName
    }
  }
`;

interface ApplicantNamePickerProps {
  onChange: (value: string) => void;
  onSelect: (baId: string | null, isLookupValue: boolean, value: string) => void;
  value?: string;
  id?: string;
  disabled?: boolean;
}

const ApplicantNamePicker: React.FC<ApplicantNamePickerProps> = ({
  onChange,
  onSelect,
  value,
  id,
  disabled,
}) => {
  const [options, setOptions] = useState([]);
  const [searchBAInfo, { data, error }] = useLazyQuery(SEARCH_BAINFO_QUERY);

  useEffect(() => {
    if (data) {
      const newOptions = data.bussinessAssociates.map((baInfo: any) => ({
        value: baInfo.longName,
        baId: baInfo.baId,
        key: baInfo.baId,
      }));
      setOptions(newOptions);
    }
    if (error) {
      notification.error({
        message: 'Error fetching business associate',
        description: error.message || 'An unknown error occurred.',
      });
    }
  }, [data, error]);

  const handleSearch = (value: string) => {
    if (value.length >= 4) {
      searchBAInfo({ variables: { input: value } });
    } else {
      setOptions([]);
    }
    onChange(value); // Call onChange with the current input value
  };

  const handleSelect = (value: string, option: any) => {
    onSelect(option.baId, true, value); // Call onSelect with baId, true indicating a lookup value was selected, and value
  };

  return (
    <AutoComplete
      id={id}
      disabled={disabled}
      options={options}
      onSearch={handleSearch}
      onSelect={handleSelect}
      onChange={(value) => onSelect(null, false, value)} // Clear baId and indicate the user is typing
      value={value}
      placeholder="Enter name"
      filterOption={(inputValue, option) =>
        option?.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
    />
  );
};

export default ApplicantNamePicker;
